import React, { useEffect, useState, SyntheticEvent } from "react"

import { PAGES } from "../../constants/localization";
import CardApi from "../../api/card";
import FlowScreen from "../../components/Layouts/FlowScreen";
import InputSkeletonGroup from "../../components/Common/Loaders/InputSkeleton";
import i18n from "../../i18n/config";
import { CardLockFaqType } from "../../types/api/card";

const FAQ = () => {
  const [faqData, setFaqData] = useState<CardLockFaqType[]>([]);
  const [detailsState, setDetailsState] = useState<{ open: boolean }[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFAQs();
  }, []);

  const getFAQs = async () => {
    try {
      // Fetch FAQs from the API
      const { lockFaqsList } = await CardApi.GetCardLockFAQs();
      setFaqData(lockFaqsList);
      setDetailsState(lockFaqsList.map(() => ({ open: false })));
      setLoading(false);
    } catch (err) {
      console.error("Error fetching FAQs:", err);
      setLoading(false);
    }
  };

  const handleOpen = (e: SyntheticEvent<HTMLElement, Event>) => {
    const target = e.target as HTMLDetailsElement;
    const index = faqData.findIndex(item => item.faqTitle === target.querySelector("summary div p")?.textContent);

    if (index === -1) return;

    if (target.open) {
      detailsState[index].open = true;
    } else {
      detailsState[index].open = false;
    }

    setDetailsState([...detailsState]);
  }

  return (
    <FlowScreen
      flowTitle={i18n.t("PAGES.MY_CARD.FAQ.TITLE")}
      className="v3"
      showBackButton={true}
    >
      {loading &&
        <InputSkeletonGroup numInputs={2} />
      }

      {!loading &&
        <div className="accordion panel panel-default max-w-50">
          <ul className="list-group">
            {faqData.length > 0 && detailsState.length > 0 &&
              faqData.map((item, index) => (
                <li className="list-group-item" key={item.faqTitle}>
                  <div className="flex-row justify-content-between align-items-center">
                    <details onToggle={(e) => handleOpen(e)}>
                      <summary>
                        <div className="flex-row justify-content-between align-items-center">
                          <p className="bold">{item.faqTitle}</p>
                          <span>{detailsState[index].open ? '-' : '+'} </span>
                        </div>
                      </summary>
                      {item.formattingType === PAGES.MY_CARD.LOCK_CARD.HTML &&
                        <div dangerouslySetInnerHTML={{ __html: item.faqDetail }}>
                        </div>
                      }

                      {item.formattingType === PAGES.MY_CARD.LOCK_CARD.TEXT &&
                        <div>
                          <p>{item.faqDetail}</p>
                        </div>
                      }
                    </details>
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
      }
    </FlowScreen>
  );
}

export default FAQ;